/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";

import {
  Table,
  Button,
  Select,
  Typography,
  Spin,
} from "antd";
import SearchInput from "../../InitialData/TbSetItem/SearchInput";
import SmartSelect from "../../InitialData/TbSetItem/SmartSelect";
import Pagination from "../../../components/Pagination";

// Utils
import { getAlert, getDataWithComp } from "../../../../utils/SamuiUtils";
import WarehouseItemModal from "../../../components/Modal/WarehouseItemModal";
import { submitItems } from "../../../../utils/services";

import dayjs from "dayjs";

const pick = (r, keys) => {
  for (const k of keys) {
    const v = r?.[k];
    if (v !== undefined && v !== null && String(v) !== "") return String(v);
  }
  return "";
};

const hashKey = (obj) => {
  const s = JSON.stringify(obj);
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = (h * 33) ^ s.charCodeAt(i);
  return (h >>> 0).toString(36);
};

const makeStableKey = (r) => {
  if (r.Item_Id) return String(r.Item_Id);
  const idShape = {
    code: r.Item_Code ?? "",
    name: r.Item_Name ?? "",
    unit: r.Item_Unit_IN ?? "",
    size: r.Item_Size ?? "",
    colour: r.Item_Colour ?? "",
    series: r.Item_Series ?? "",
    brand: r.Item_Brand ?? "",
  };
  return `itm_${hashKey(idShape)}`;
};

const getSelVal = (v) =>
  v && typeof v === "object" ? v.value ?? v.key ?? "" : v ?? "";

const getSelLabel = (v) =>
  v && typeof v === "object" ? v.label ?? v.value ?? "" : String(v ?? "");

const buildInitialData = (rows = [], whByItemId = {}) => {
  if (!rows.length) return null;
  const r0 = rows[0] || {};

  const allWH = new Set();
  const details = rows.map((r, i) => {
    const iid = Number(r.Item_Id);
    const info = whByItemId[iid] || { whIds: new Set(), whNames: new Set() };
    info.whIds.forEach((id) => allWH.add(id));
    const statusYN = r.Item_Status ?? r.StatusYN ?? "Y";
    return {
      key: r.Item_Code || r.Item_Barcode || String(r.Item_Id ?? i),
      Item_Id: r.Item_Id,
      Item_Barcode: r.Item_Barcode ?? "",
      Item_Code: r.Item_Code ?? "",
      Item_Name: r.Item_Name ?? "",
      Item_Short_Name: r.Item_Short_Name ?? r.Item_Shortname ?? "",
      Item_Code_Master: r.Item_Code_Master ?? "",
      Unit: r.Item_Unit_IN ?? r.Unit ?? "",
      Item_Qty: Number(r.Item_Qty ?? r.Qty ?? 0),
      Item_Is_Sale: r.Item_Is_Sale ?? "N",
      Item_Is_Service: r.Item_Is_Service ?? "N",
      Colour: r.Item_Colour ?? r.Colour ?? "",
      Size: r.Item_Size ?? r.Size ?? "",
      Brand: r.Item_Brand ?? r.Brand ?? "",
      Series: r.Item_Series ?? r.Series ?? "",
      Warehouses: Array.from(info.whNames).join(", "),
      InitQty: Number(r.Init_Qty ?? 0),
      Cost: Number(r.Item_Cost ?? r.Cost ?? 0),
      CreatedAt: r.CreatedAt ?? r.Created_At ?? "",
      CreatedBy: r.CreatedBy ?? r.Created_By ?? "",
      UpdatedAt: r.UpdatedAt ?? r.Updated_At ?? "",
      UpdatedBy: r.UpdatedBy ?? r.Updated_By ?? "",
      Price1: Number(r.Price1 ?? r.Item_Price ?? 0),
      Price2: Number(r.Price2 ?? r.Item_PriceA ?? 0),
      Price3: Number(r.Price3 ?? r.Item_PriceB ?? 0),
      StatusYN: statusYN,
      Status: statusYN === "Y" ? "Active" : "In-Active",
      WH_Ids: Array.from(info.whIds),
    };
  });

  const header = {
    Item_Group: r0.Item_Group ?? r0.Group_Id ?? "",
    Item_Short_Name: r0.Item_Short_Name ?? "",
    Item_Name: r0.Item_Name ?? "",
    Item_Name_EN: r0.Item_Name_EN ?? "",
    Item_Unit_IN: r0.Item_Unit_IN ?? r0.Unit ?? "",
    Item_Qty: Number(r0.Item_Qty ?? r0.Qty ?? 0),
    Item_Is_Sale: r0.Item_Is_Sale ?? "N",
    Item_Is_Service: r0.Item_Is_Service ?? "N",
    Item_Brand: r0.Item_Brand ?? "",
    Item_Series: r0.Item_Series ?? "",
    Item_Cost: Number(r0.Item_Cost ?? r0.Cost ?? 0),
    Item_Price: Number(r0.Item_Price ?? r0.Price1 ?? 0),
    Item_PriceA: Number(r0.Item_PriceA ?? r0.Price2 ?? 0),
    Item_PriceB: Number(r0.Item_PriceB ?? r0.Price3 ?? 0),
    Item_Status: r0.Item_Status ?? r0.StatusYN ?? "Y",
    Item_Short_Name2: r0.Item_Short_Name ?? "",
    WH_Ids: Array.from(allWH),
    Init_Qty_All: Number(r0.Init_Qty ?? 0),
  };
  const filledDetails = details.map((d) => ({
    ...d,
    WH_Ids:
      Array.isArray(d.WH_Ids) && d.WH_Ids.length ? d.WH_Ids : header.WH_Ids,
  }));

  return { header, details: filledDetails };
};

function Main({ masterList, detailList, name }) {
  const lastFocusKeyRef = useRef(null);
  const [dataMasterList, setDataMasterList] = useState([]);
  const [groupMasterList, setGroupMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [kwDraft, setKwDraft] = useState("");
  const [kw, setKw] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRowKey, setSelectedRowKey] = useState(null);

  const searchRef = React.useRef(null);
  const dataMasterListRef = useRef([]);

  const scrollPositionRef = React.useRef({ scrollTop: 0, scrollLeft: 0 });
  const shouldRestoreScrollRef = React.useRef(false);

  const [pendingFilters, setPendingFilters] = useState({
    createdRange: { start: null, end: null },
    group: undefined,
    brand: undefined,
    series: undefined,
    status: undefined,
    _kw: "",
  });

  const [modalState, setModalState] = useState({
    open: false,
    mode: "create",
    data: null,
    focusKey: null,
  });

  const [filters, setFilters] = useState(pendingFilters);

  const tableWrapRef = useRef(null);
  const footerRef = useRef(null);
  const [scrollY, setScrollY] = useState(480);
  const totalItems = totalItemsCount || dataMasterList.length;
  const startIdx = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIdx = Math.min(currentPage * itemsPerPage, totalItems);
  const displayItems = dataMasterList;

  const recomputeScrollY = () => {
    const wrap = tableWrapRef.current;
    if (!wrap) return;
    const rect = wrap.getBoundingClientRect();
    const viewportH =
      window.innerHeight || document.documentElement.clientHeight;
    const bottomGap = 16;
    const available = Math.max(200, viewportH - rect.top - bottomGap);
    const footerH = footerRef.current?.offsetHeight ?? 0;
    const thead =
      wrap.querySelector(".ant-table-header") ||
      wrap.querySelector(".ant-table-thead");

    const theadH = thead?.offsetHeight ?? 48;
    setScrollY(Math.max(160, available - footerH - theadH));
  };

  const restoreTableScroll = React.useCallback(() => {
    requestAnimationFrame(() => {
      const tableBody = tableWrapRef.current?.querySelector(".ant-table-body");
      if (tableBody && scrollPositionRef.current) {
        tableBody.scrollTop = scrollPositionRef.current.scrollTop;
        tableBody.scrollLeft = scrollPositionRef.current.scrollLeft;
      }
    });
  }, []);

  const onRowSelected = React.useCallback(async (item, currentList = []) => {
    try {
      const tableBody = tableWrapRef.current?.querySelector(".ant-table-body");
      if (tableBody) {
        scrollPositionRef.current = {
          scrollTop: tableBody.scrollTop,
          scrollLeft: tableBody.scrollLeft,
        };
        shouldRestoreScrollRef.current = true;
      }

      const rowKey = item._key || makeStableKey(item);
      setSelectedRowKey(rowKey);

      const targetShortName = pick(item, ["Item_Short_Name"]) || "";
      const targetBrand = pick(item, ["Item_Brand"]) || "";
      const targetSeries = pick(item, ["Item_Series"]) || "";
      const targetColour = pick(item, ["Item_Colour"]) || "";

      if (!targetShortName) {
        getAlert("FAILED", "ไม่พบชื่อสินค้าหลัก");
        return;
      }

      const list = (dataMasterListRef.current || []).filter((r) => {
        const rShortName = pick(r, ["Item_Short_Name"]) || "";
        const rBrand = pick(r, ["Item_Brand"]) || "";
        const rSeries = pick(r, ["Item_Series"]) || "";
        const rColour = pick(r, ["Item_Colour"]) || "";

        return (
          rShortName === targetShortName &&
          rBrand === targetBrand &&
          rSeries === targetSeries &&
          rColour === targetColour
        );
      });

      if (!list.length) {
        getAlert("FAILED", "ไม่พบรายการของสินค้าเพื่อแก้ไข");
        return;
      }

      const sortedList = list.sort((a, b) => {
        const rankSizeA = Number(a.Size_Line ?? Number.MAX_SAFE_INTEGER);
        const rankSizeB = Number(b.Size_Line ?? Number.MAX_SAFE_INTEGER);

        if (rankSizeA !== rankSizeB) return rankSizeA - rankSizeB;

        const sizeA = pick(a, ["Item_Size"]) || "";
        const sizeB = pick(b, ["Item_Size"]) || "";
        return sizeA.localeCompare(sizeB, "th");
      });

      const ids = sortedList
        .map((r) => Number(r.Item_Id))
        .filter(Number.isFinite);

      if (!ids.length) {
        getAlert("FAILED", "ไม่พบ Item_Id ของสินค้า");
        return;
      }

      const stcRows = await getDataWithComp(
        "WH_ITEM_STC",
        `AND Item_Id IN (${ids.join(",")})`
      );

      const stcs = Array.isArray(stcRows) ? stcRows : [];
      const whByItemId = {};
      for (const s of stcs) {
        const iid = Number(s.Item_Id);
        const wid = Number(s.WH_Id);
        if (!Number.isFinite(iid) || !Number.isFinite(wid)) continue;

        if (!whByItemId[iid]) {
          whByItemId[iid] = { whIds: new Set(), whNames: new Set() };
        }
        whByItemId[iid].whIds.add(wid);
      }

      const allWHIds = Array.from(
        new Set(Object.values(whByItemId).flatMap((v) => Array.from(v.whIds)))
      );
      let whNameMap = {};
      if (allWHIds.length) {
        const whMst = await getDataWithComp(
          "Tb_Set_WH",
          `AND WH_Id IN (${allWHIds.join(",")}) AND WH_Status='Y'`
        );
        (Array.isArray(whMst) ? whMst : []).forEach((w) => {
          whNameMap[Number(w.WH_Id)] = w.WH_Name ?? String(w.WH_Id);
        });
      }

      for (const iid of Object.keys(whByItemId)) {
        const info = whByItemId[iid];
        for (const wid of info.whIds) {
          info.whNames.add(whNameMap[wid] ?? String(wid));
        }
      }

      const initialData = buildInitialData(sortedList, whByItemId);
      const focusKey = String(
        item?.Item_Code ?? item?.Item_Barcode ?? item?.Item_Id ?? ""
      );
      lastFocusKeyRef.current = focusKey || null;

      setModalState({
        open: true,
        mode: "edit",
        data: focusKey ? { ...initialData, __focusKey: focusKey } : initialData,
        focusKey: focusKey,
      });
    } catch (e) {
      console.error(e);
      getAlert("FAILED", "โหลดข้อมูลสินค้าไม่สำเร็จ");
    }
  }, []);

  const resolveSelectedKey = React.useCallback((list = []) => {
    const focusKey = lastFocusKeyRef.current;
    if (!focusKey) return null;
    const match = list.find((r) => {
      const key = String(
        r?.Item_Code ?? r?.Item_Barcode ?? r?.Item_Id ?? ""
      );
      return key === String(focusKey);
    });
    return match ? makeStableKey(match) : null;
  }, []);

  const onPageInsert = React.useCallback(() => {
    setModalState({
      open: true,
      mode: "create",
      data: null,
      focusKey: null,
    });
  }, []);

  const { Text } = Typography;

  const [loading, setLoading] = useState(false);
  const lastReqIdRef = useRef(0);
  const norm = (v) =>
    String(v ?? "")
      .trim()
      .replace(/\s+/g, " ")
      .toUpperCase();
  const applyFilters = React.useCallback(
    async (kwFromUI = "", overrideFilters, options = {}) => {
      const curKw = String(kwFromUI ?? "");
      setKw(curKw);

      const baseFilters = overrideFilters ?? pendingFilters;
      const nextFilters = { ...baseFilters, _kw: curKw };
      setFilters(nextFilters);
      setPendingFilters(nextFilters);
      setLoading(true);

      try {
        const page = options.page ?? currentPage;
        const perPage = options.perPage ?? itemsPerPage;
        const includeTotal = options.includeTotal ?? false;
        const where = buildWhereFromFilters(nextFilters);
        const reqId = ++lastReqIdRef.current;
        const orderBy =
          " ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line, Item_Id";
        const [rows, groupRows] = await Promise.all([
          getDataWithComp("View_Set_Item", where + orderBy, {
            fields: [
              "Item_Id",
              "Item_Barcode",
              "Item_Code",
              "Item_Name",
              "Item_Short_Name",
              "Item_Code_Master",
              "Item_Unit_IN",
              "Item_Qty",
              "Item_Is_Sale",
              "Item_Is_Service",
              "Item_Colour",
              "Item_Size",
              "Item_Brand",
              "Item_Series",
              "Init_Qty",
              "Item_Cost",
              "CreatedAt",
              "Created_At",
              "CreatedBy",
              "Created_By",
              "UpdatedAt",
              "Updated_At",
              "UpdatedBy",
              "Updated_By",
              "Item_Price",
              "Item_PriceA",
              "Item_PriceB",
              "Item_Status",
              "Item_Group",
              "Group_Id",
              "Item_Onhand",
            ],
            limit: perPage,
            offset: (page - 1) * perPage,
            includeTotal,
          }),
          groupMasterList.length
            ? Promise.resolve(groupMasterList)
            : getDataWithComp(
                "Tb_Set_ItmGroup",
                "AND Group_Status='Y' ORDER BY Group_Id ASC"
              ),
        ]);

        if (reqId !== lastReqIdRef.current) return;

        const groupList = Array.isArray(groupRows) ? groupRows : [];
        if (!groupMasterList.length && groupList.length) {
          setGroupMasterList(groupList);
        }
        const groupMap = new Map(
          groupList.map((g) => [
            String(g.Group_Id ?? g.id ?? ""),
            g.Group_Name ?? g.name ?? "",
          ])
        );
        const list = Array.isArray(rows) ? rows : [];
        if (includeTotal) {
          const total = Number(list?.[0]?.Total_Count ?? 0);
          setTotalItemsCount(Number.isNaN(total) ? 0 : total);
        }
        let nextList = list.map((r) => ({
          ...r,
          Group_Name:
            r.Group_Name ??
            groupMap.get(String(r.Item_Group ?? r.Group_Id ?? "")) ??
            "",
          _key: makeStableKey(r),
        }));
        // Always fetch onhand for warehouse items
        if (nextList.length) {
          const ids = Array.from(
            new Set(
              nextList
                .map((r) => Number(r.Item_Id))
                .filter((id) => Number.isFinite(id))
            )
          );
          const onhandMap = await fetchOnhandMap(ids);
          nextList = nextList.map((r) => ({
            ...r,
            Item_Onhand:
              onhandMap[Number(r.Item_Id)] ??
              r.Item_Onhand ??
              r.Item_OnHand ??
              r.Item_Qty ??
              r.Init_Qty ??
              0,
          }));
        }
        const nextSelectedKey = resolveSelectedKey(nextList);
        setDataMasterList(nextList);
        if (nextSelectedKey) {
          setSelectedRowKey(nextSelectedKey);
        } else if (lastFocusKeyRef.current) {
          setSelectedRowKey(null);
        }
      } catch (e) {
        console.error(e);
        getAlert("FAILED", "ดึงข้อมูลไม่สำเร็จ");
      } finally {
        setLoading(false);
      }
    },
    [pendingFilters, groupMasterList, currentPage, itemsPerPage]
  );

  const handleFilterChange = (field, value) => {
    const nextFilters = { ...pendingFilters, [field]: value };
    setPendingFilters(nextFilters);
    setSelectedRowKey(null);
    setCurrentPage(1);
    const v = searchRef.current?.getValue?.() ?? kwDraft;
    applyFilters(v, nextFilters, { page: 1, includeTotal: true });
  };

  const chexkLoading = () => {
    setIsLoading(false);
  };

  const initialize = async () => {
    try {
      const list = Array.isArray(masterList) ? masterList : [];
      let groups = groupMasterList;
      if (!groups.length) {
        const fetched = await getDataWithComp(
          "Tb_Set_ItmGroup",
          "AND Group_Status='Y' ORDER BY Group_Id ASC"
        );
        groups = Array.isArray(fetched) ? fetched : [];
        if (groups.length) setGroupMasterList(groups);
      }
      const groupMap = new Map(
        groups.map((g) => [
          String(g.Group_Id ?? g.id ?? ""),
          g.Group_Name ?? g.name ?? "",
        ])
      );
      if (list.length > 0) {
        const withKey = list.map((r) => ({
          ...r,
          Group_Name:
            r.Group_Name ??
            groupMap.get(String(r.Item_Group ?? r.Group_Id ?? "")) ??
            "",
          _key: makeStableKey(r),
        }));
        setDataMasterList(withKey);
        const nextSelectedKey = resolveSelectedKey(withKey);
        if (nextSelectedKey) {
          setSelectedRowKey(nextSelectedKey);
        }
      } else {
        setDataMasterList([]);
      }
      chexkLoading();
    } catch (e) {
      getAlert("FAILED", e.message);
    }
  };

  const cmpStrBy = (keys) => (a, b) =>
    pick(a, keys).localeCompare(pick(b, keys), "th");
  const cmpNumBy = (keys) => (a, b) =>
    (parseFloat(pick(a, keys)) || 0) - (parseFloat(pick(b, keys)) || 0);
  const cmpDateBy = (keys) => (a, b) => {
    const da = dayjs(pick(a, keys) || 0);
    const db = dayjs(pick(b, keys) || 0);
    return da.valueOf() - db.valueOf();
  };

  const fmt = (v) => Number(v || 0).toLocaleString();
  const getQtyValue = (record) =>
    Number(
      record?.Item_Onhand ??
        record?.Item_OnHand ??
        record?.Init_Qty ??
        record?.InitQty ??
        record?.Item_Qty ??
        0
    );
  const fetchOnhandMap = React.useCallback(async (itemIds = []) => {
    const map = {};
    if (!itemIds.length) return map;
    const chunkSize = 200;
    for (let i = 0; i < itemIds.length; i += chunkSize) {
      const chunk = itemIds.slice(i, i + chunkSize);
      const rows = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND Item_Id IN (${chunk.join(",")})`
      );
      (Array.isArray(rows) ? rows : []).forEach((r) => {
        const id = Number(r.Item_Id);
        const qty = Number(
          r.Item_Onhand ?? r.Item_OnHand ?? r.Onhand ?? r.OnHand ?? 0
        );
        if (Number.isFinite(id)) {
          map[id] = (map[id] ?? 0) + (Number.isFinite(qty) ? qty : 0);
        }
      });
    }
    return map;
  }, []);
  const getUsageLabel = (record) => {
    const isSale = String(
      record?.Item_Is_Sale ??
        record?.Item_Sale_Use ??
        record?.Item_Sale ??
        ""
    ).toUpperCase();
    const isService = String(
      record?.Item_Is_Service ??
        record?.Item_Service_Use ??
        record?.Item_Service ??
        ""
    ).toUpperCase();
    const labels = [];
    if (isSale === "Y" || isSale === "1" || isSale === "TRUE") {
      labels.push("สำหรับจำหน่าย");
    }
    if (isService === "Y" || isService === "1" || isService === "TRUE") {
      labels.push("สำหรับใช้ในบริการ");
    }
    return labels.length ? labels.join(", ") : "-";
  };

  const CopyCell = ({ text }) => (
    <Text
      copyable={{ text, tooltips: ["คัดลอก", "คัดลอกแล้ว"] }}
      ellipsis={{ tooltip: text }}
      style={{ display: "inline-block", maxWidth: "100%" }}
    >
      {text}
    </Text>
  );

  const takeRaw = (r, keys) => {
    for (const k of keys) {
      const v = r?.[k];
      if (v !== undefined && v !== null && String(v).trim() !== "") {
        const raw = String(v).trim();
        return { raw, n: norm(raw) };
      }
    }
    return { raw: "", n: "" };
  };

  const uniqueOptions = (rows, keys) => {
    const map = new Map();
    for (const r of rows) {
      const { raw, n } = takeRaw(r, Array.isArray(keys) ? keys : [keys]);
      if (!n) continue;
      if (!map.has(n)) map.set(n, raw);
    }
    const arr = Array.from(map.values()).map((label) => ({
      value: label,
      label,
    }));
    arr.sort((a, b) => a.label.localeCompare(b.label, "th"));
    return arr;
  };

  const fmtDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);

    const pad = (n) => String(n).padStart(2, "0");

    return (
      pad(d.getUTCDate()) +
      "/" +
      pad(d.getUTCMonth() + 1) +
      "/" +
      (d.getUTCFullYear() + 543) +
      " " +
      pad(d.getUTCHours()) +
      ":" +
      pad(d.getUTCMinutes())
    );
  };

  const widthcolumns = {
    rowno: 70,
    group: 130,
    code: 180,
    name: 450,
    qty: 120,
    usage: 180,
    brand: 120,
    series: 120,
    price1: 110,
    price2: 110,
    price3: 110,
    created_date: 160,
    created_by: 140,
    update_date: 160,
    update_by: 140,
    edit: 80,
  };
  const w = (k) => widthcolumns[k];

  const columns = (currentPage, itemsPerPage, onRowSelected) => [
    {
      title: "ลำดับ",
      key: "rowno",
      width: w("rowno"),
      align: "center",
      fixed: "left",
      sorter: (a, b) => 0,
      render: (_v, r, idx) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return idx + 1 + (currentPage - 1) * itemsPerPage;
      },
    },
    {
      title: "หมวดหมู่สินค้า",
      key: "group",
      dataIndex: "Item_Group_Name",
      width: w("group"),
      fixed: "left",
      render: (_, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return <CopyCell text={displayGroupName(r)} />;
      },
      sorter: (a, b) =>
        displayGroupName(a).localeCompare(displayGroupName(b), "th"),
    },
    {
      title: "รหัสสินค้า",
      dataIndex: "Item_Code",
      key: "Item_Code",
      width: w("code"),
      fixed: "left",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return (
          <CopyCell text={String(v ?? "")} style={{ textAlign: "left" }} />
        );
      },
      sorter: cmpStrBy(["Item_Code"]),
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "Item_Name",
      key: "Item_Name",
      width: w("name"),
      align: "left",
      fixed: "left",
      render: (v, record) => {
        if (record._isEmpty) {
          return {
            children: (
              <div
                style={{
                  padding: "40px 0",
                  color: "#999",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    marginBottom: "8px",
                    fontWeight: 500,
                  }}
                >
                  ไม่พบข้อมูล
                </div>
                <div style={{ fontSize: "14px" }}>
                  กรุณาลองค้นหาด้วยเงื่อนไขอื่น
                </div>
              </div>
            ),
            props: { colSpan: 16 },
          };
        }

        return (
          <a
            href="#"
            className="item-name-link"
            onClick={(e) => {
              onRowSelected?.(record, displayItems);
            }}
          >
            {String(v ?? "")}
          </a>
        );
      },
      sorter: cmpStrBy(["Item_Name"]),
    },
    {
      title: "ปริมาณ",
      dataIndex: "Item_Onhand",
      key: "Item_Onhand",
      width: w("qty"),
      align: "center",
      render: (_v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        const qty = getQtyValue(r);
        const unit = r.Item_Unit_IN || r.Unit || "";
        if (!qty) return fmt(qty);
        return unit ? `${fmt(qty)} ${unit}` : fmt(qty);
      },
      sorter: (a, b) => getQtyValue(a) - getQtyValue(b),
    },
    {
      title: "การใช้งาน",
      dataIndex: "Item_Usage",
      key: "Item_Usage",
      width: w("usage"),
      align: "center",
      render: (_v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return getUsageLabel(r);
      },
      sorter: (a, b) =>
        getUsageLabel(a).localeCompare(getUsageLabel(b), "th"),
    },
    {
      title: "ยี่ห้อ",
      dataIndex: "Item_Brand",
      key: "Item_Brand",
      width: w("brand"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: cmpStrBy(["Item_Brand"]),
    },
    {
      title: "รุ่น",
      dataIndex: "Item_Series",
      key: "Item_Series",
      width: w("series"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: cmpStrBy(["Item_Series"]),
    },
    {
      title: "ราคาสินค้า1",
      dataIndex: "Item_Price",
      key: "Item_Price",
      width: w("price1"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_Price"]),
    },
    {
      title: "ราคาสินค้า2",
      dataIndex: "Item_PriceA",
      key: "Item_PriceA",
      width: w("price2"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_PriceA"]),
    },
    {
      title: "ราคาสินค้า3",
      dataIndex: "Item_PriceB",
      key: "Item_PriceB",
      width: w("price3"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_PriceB"]),
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "Created_Date",
      key: "Created_Date",
      width: w("created_date"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmtDate(v || r.CreatedAt || r.Created_At);
      },
      sorter: cmpDateBy(["Created_Date", "CreatedAt", "Created_At"]),
    },
    {
      title: "สร้างโดย",
      dataIndex: "Created_By_Name",
      key: "Created_By_Name",
      width: w("created_by"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v || r.CreatedBy || r.Created_By || "-";
      },
      sorter: cmpStrBy(["Created_By_Name", "CreatedBy", "Created_By"]),
    },
    {
      title: "วันที่แก้ไข",
      dataIndex: "Update_Date",
      key: "Update_Date",
      width: w("update_date"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmtDate(v || r.UpdatedAt || r.Updated_At);
      },
      sorter: cmpDateBy(["Update_Date", "UpdatedAt", "Updated_At"]),
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "Update_By_Name",
      key: "Update_By_Name",
      width: w("update_by"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v || r.UpdatedBy || r.Updated_By || "-";
      },
      sorter: cmpStrBy(["Update_By_Name", "UpdatedBy", "Updated_By"]),
    },
    {
      title: "แก้ไข",
      key: "edit",
      width: w("edit"),
      align: "center",
      fixed: "right",
      sorter: (a, b) => 0,
      render: (_, record) => {
        if (record._isEmpty) return { props: { colSpan: 0 } };
        return (
          <i
            className="fas fa-edit fw-bold"
            style={{ color: "#E13F57", cursor: "pointer" }}
            title="แก้ไข"
            onClick={(e) => {
              e.stopPropagation();
              onRowSelected?.(record, displayItems);
            }}
          />
        );
      },
    },
  ];

  const groupNameMap = useMemo(
    () =>
      new Map(
        (groupMasterList || []).map((g) => [
          String(g.Group_Id ?? g.id ?? ""),
          g.Group_Name ?? g.name ?? "",
        ])
      ),
    [groupMasterList]
  );

  const displayGroupName = (r) => {
    const fromRow = r.Group_Name || "";
    if (fromRow) return fromRow;
    const id = String(r.Item_Group ?? r.Group_Id ?? "");
    return groupNameMap.get(id) || "-";
  };

  const options = React.useMemo(() => {
    const rows = dataMasterList || [];
    const groupSet = new Set();
    const groupOpts = [];
    const sourceGroups =
      groupMasterList.length > 0 ? groupMasterList : rows;
    for (const r of sourceGroups) {
      const id = String(r.Group_Id ?? r.Item_Group ?? "").trim();
      const name = String(r.Group_Name ?? r.name ?? "").trim();
      if (id && name && !groupSet.has(id)) {
        groupSet.add(id);
        groupOpts.push({ value: id, label: name });
      }
    }
    groupOpts.sort((a, b) => a.label.localeCompare(b.label, "th"));

    const brands = uniqueOptions(rows, ["Item_Brand"]);
    const series = uniqueOptions(rows, ["Item_Series"]);

    return {
      groups: groupOpts,
      brands,
      series,
      statuses: [
        { value: "Y", label: "พร้อมขาย" },
        { value: "N", label: "ไม่พร้อมขาย" },
      ],
    };
  }, [dataMasterList, groupMasterList]);

  const handleRowClick = React.useCallback((record) => {
    const tableBody = tableWrapRef.current?.querySelector(".ant-table-body");
    if (tableBody) {
      scrollPositionRef.current = {
        scrollTop: tableBody.scrollTop,
        scrollLeft: tableBody.scrollLeft,
      };
      shouldRestoreScrollRef.current = true;
    }

    setSelectedRowKey(record._key || makeStableKey(record));
  }, []);

  const tableColumns = React.useMemo(
    () => columns(currentPage, itemsPerPage, onRowSelected),
    [currentPage, itemsPerPage, onRowSelected]
  );

  const esc = (s = "") => String(s).replaceAll("'", "''");
  const like = (s = "") => `%${esc(String(s).trim())}%`;

  const buildWhereFromFilters = React.useCallback(
    (f) => {
      const { createdRange, group, brand, series, status, _kw } = f || {};
      const parts = [];

      if (_kw && String(_kw).trim() !== "") {
        const kw = like(_kw);
        parts.push(
          `AND (Item_Code LIKE '${kw}' OR Item_Name LIKE '${kw}' OR Item_Barcode LIKE '${kw}'
       OR Item_Series LIKE '${kw}' OR Item_Brand LIKE '${kw}')`
        );
      }

      if (group) {
        const raw = String(getSelVal(group) ?? "").trim();
        const gidNum = Number(raw);
        if (Number.isFinite(gidNum)) {
          parts.push(`AND Item_Group=${gidNum}`);
        }
      }

      if (brand)
        parts.push(
          `AND Item_Brand='${esc(getSelVal(brand) || getSelLabel(brand))}'`
        );
      if (series)
        parts.push(
          `AND Item_Series='${esc(getSelVal(series) || getSelLabel(series))}'`
        );
      if (status)
        parts.push(
          `AND (Item_Status='${esc(
            getSelVal(status) || getSelLabel(status)
          )}' OR StatusYN='${esc(getSelVal(status) || getSelLabel(status))}')`
        );

      if (createdRange?.start || createdRange?.end) {
        const s = createdRange?.start
          ? dayjs(createdRange.start)
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          : null;
        const e = createdRange?.end
          ? dayjs(createdRange.end).endOf("day").format("YYYY-MM-DD HH:mm:ss")
          : null;
        if (s) parts.push(`AND (CreatedAt >= '${s}' OR Created_At >= '${s}')`);
        if (e) parts.push(`AND (CreatedAt <= '${e}' OR Created_At <= '${e}')`);
      }

      return parts.join(" ");
    },
    [getSelVal, getSelLabel]
  );
  const ItemsTable = React.memo(
    function ItemsTable({
      loading,
      columns,
      data,
      scrollY,
      selectedRowKey,
      onRowClick,
    }) {
      const tableData =
        data.length === 0 ? [{ _key: "empty-row", _isEmpty: true }] : data;

      return (
        <Table
          loading={loading}
          size="small"
          rowKey="_key"
          columns={columns}
          rowClassName={(record) => {
            if (record._isEmpty) return "";
            if (record._key === selectedRowKey) return "ant-table-row-selected";
            return "";
          }}
          onRow={(record) => ({
            style: record._isEmpty ? { pointerEvents: "none" } : undefined,
            onClick: () => {
              if (!record._isEmpty && onRowClick) {
                onRowClick(record);
              }
            },
          })}
          dataSource={tableData}
          bordered
          sticky
          scroll={{ x: "max-content", y: scrollY }}
          pagination={false}
          locale={{
            emptyText: (
              <div style={{ padding: "40px 0", color: "#999" }}>
                <div style={{ fontSize: "16px", marginBottom: "8px" }}>
                  ไม่พบข้อมูล
                </div>
                <div style={{ fontSize: "14px" }}>
                  กรุณาลองค้นหาด้วยเงื่อนไขอื่น
                </div>
              </div>
            ),
          }}
        />
      );
    },
    (prevProps, nextProps) => {
      return (
        prevProps.loading === nextProps.loading &&
        prevProps.scrollY === nextProps.scrollY &&
        prevProps.selectedRowKey === nextProps.selectedRowKey &&
        prevProps.data.length === nextProps.data.length &&
        prevProps.columns === nextProps.columns &&
        prevProps.onRowClick === nextProps.onRowClick
      );
    }
  );

  useEffect(() => {
    dataMasterListRef.current = dataMasterList;
  }, [dataMasterList]);

  useEffect(() => {
    const ro = new ResizeObserver(() => recomputeScrollY());
    if (tableWrapRef.current) ro.observe(tableWrapRef.current);
    window.addEventListener("resize", recomputeScrollY);
    recomputeScrollY();
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", recomputeScrollY);
    };
  }, []);

  useEffect(() => {
    recomputeScrollY();
  }, [dataMasterList.length, itemsPerPage, currentPage]);

  useEffect(() => {
    const pages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    if (currentPage > pages) setCurrentPage(pages);
  }, [totalItems, itemsPerPage]);

  useEffect(() => {
    if (!loading && !isLoading && shouldRestoreScrollRef.current) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const tableBody =
            tableWrapRef.current?.querySelector(".ant-table-body");
          if (tableBody && scrollPositionRef.current) {
            tableBody.scrollTop = scrollPositionRef.current.scrollTop;
            tableBody.scrollLeft = scrollPositionRef.current.scrollLeft;
            shouldRestoreScrollRef.current = false;
          }
        });
      });
    }
  }, [loading, isLoading, dataMasterList]);

  useEffect(() => {
    if (!modalState.open) {
      restoreTableScroll();
    }
  }, [modalState.open, restoreTableScroll]);

  const didInit = useRef(false);

  useEffect(() => {
    initialize();
    if (!didInit.current) {
      didInit.current = true;
      applyFilters(kw, undefined, { page: 1, includeTotal: true });
    }
  }, [masterList, detailList]);

  return (
    <>
      <Spin spinning={loading || isLoading} fullscreen />

      <>
        <div className="page-header d-flex justify-content-between align-items-center mb-0">
          <Breadcrumbs
            page={name}
            items={[
              { name: "คลังสินค้า", url: "/warehouse" },
              { name: name, url: "/warehouse-item" },
            ]}
          />
        </div>
        <div
          className="p-3 rounded-3 my-2 shadow-lg"
          style={{ backgroundColor: "#ffff" }}
        >
          <div className="row g-2 align-items-end">
            <div className="col-12 col-xl-2" style={{ width: 200 }}>
              <span className="d-block fw-semibold small mb-1">ค้นหา</span>
              <SearchInput
                ref={searchRef}
                value={kwDraft}
                onSearchNow={(v) => {
                  setKwDraft(v);
                  setKw(v);
                  setCurrentPage(1);
                  applyFilters(v, undefined, { page: 1, includeTotal: true });
                }}
                setSelectedRowKey={setSelectedRowKey}
                placeholder="ค้นหาข้อมูล"
              />
            </div>

            <div className="col-3 col-xl-2" style={{ width: 180 }}>
              <span className="d-block fw-semibold small mb-1">
                หมวดหมู่สินค้า
              </span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.group}
                onChange={(v) => handleFilterChange("group", v)}
                options={options.groups}
                maxRender={120}
                debounceMs={180}
                returnObject
              />
            </div>

            <div className="col-3 col-xl-2" style={{ width: 100 }}>
              <span className="d-block fw-semibold small mb-1">ยี่ห้อ</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.brand}
                onChange={(v) => handleFilterChange("brand", v)}
                options={options.brands}
              />
            </div>

            <div className="col-3 col-xl-1" style={{ width: 160 }}>
              <span className="d-block fw-semibold small mb-1">รุ่น</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.series}
                onChange={(v) => handleFilterChange("series", v)}
                options={options.series}
              />
            </div>

            <div className="col-3 col-xl-1" style={{ width: 160 }}>
              <span className="d-block fw-semibold small mb-1">สถานะ</span>
              <Select
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.status}
                onChange={(v) => handleFilterChange("status", v)}
                options={options.statuses}
              />
            </div>
            <div className="col-3 col-xl-1" style={{ width: 100 }}>
              <Button
                type="primary"
                onClick={() => {
                  const v = searchRef.current?.getValue?.() ?? kwDraft;
                  setSelectedRowKey(null);
                  setCurrentPage(1);
                  applyFilters(v, undefined, { page: 1, includeTotal: true });
                }}
                loading={loading}
              >
                ค้นหา
              </Button>
            </div>

            <div className="col-12 col-xl d-flex justify-content-xl-end">
              <div></div>

              <Button
                type="primary"
                onClick={onPageInsert}
                className="btn btn-warning text-white ms-xl-2 mt-2 mt-xl-0"
                style={{ backgroundColor: "#E13F57", borderColor: "#E13F57" }}
                icon={<i className="fa fa-plus" />}
              >
                สร้าง{name}
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card p-2">
              <div ref={tableWrapRef} style={{ position: "relative" }}>
                <ItemsTable
                  loading={loading || isLoading}
                  columns={tableColumns}
                  data={displayItems}
                  scrollY={scrollY}
                  selectedRowKey={selectedRowKey}
                  onRowClick={handleRowClick}
                />
              </div>
            </div>

            <div ref={footerRef} className="mt-2">
              <Pagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={(page) => {
                  setCurrentPage(page);
                  applyFilters(kw, filters, {
                    page,
                    perPage: itemsPerPage,
                    includeTotal: false,
                  });
                }}
                onItemsPerPageChange={(limit) => {
                  setItemsPerPage(limit);
                  setCurrentPage(1);
                  applyFilters(kw, filters, {
                    page: 1,
                    perPage: limit,
                    includeTotal: true,
                  });
                }}
              />
            </div>
          </div>
        </div>
        {/* ==== Warehouse Item Modal ==== */}
        <WarehouseItemModal
          open={modalState.open}
          setOpen={(isOpen) =>
            setModalState((prev) => ({ ...prev, open: isOpen }))
          }
          mode={modalState.mode}
          initialData={modalState.data}
          onClose={() => {
            setModalState({
              open: false,
              mode: "create",
              data: null,
              focusKey: null,
            });
          }}
          onDataChanged={async () => {
            await applyFilters(kw, filters, {
              page: currentPage,
              perPage: itemsPerPage,
              includeTotal: true,
            });
          }}
          onSubmit={async (payload) => {
            try {
              setIsLoading(true);

              const res = await submitItems(payload);

              if (res?.ok) {
                getAlert("OK", "บันทึกสำเร็จ");
                setModalState({
                  open: false,
                  mode: "create",
                  data: null,
                  focusKey: null,
                });
                await applyFilters(kw, filters, {
                  page: currentPage,
                  perPage: itemsPerPage,
                  includeTotal: true,
                });
              } else {
                console.debug("submitItems failed:", res);
              }
            } catch (e) {
              console.error(e);
              getAlert("FAILED", "บันทึกไม่สำเร็จ");
            } finally {
              setIsLoading(false);
            }
          }}
        />
        <style jsx global>{`
          .pm-overlay {
            position: fixed !important;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10550;
            overflow-y: auto;
          }

          .ant-table-body {
            scroll-behavior: auto !important;
          }

          .card {
            contain: layout style;
          }
          .items-table .ant-table-content,
          .items-table .ant-table-body {
            overflow: auto !important;
            scrollbar-gutter: stable both-edges;
            scrollbar-width: thin;
          }
          .items-table .ant-table-content::-webkit-scrollbar,
          .items-table .ant-table-body::-webkit-scrollbar {
            height: 10px;
            width: 10px;
          }
          .items-table .ant-table-content::-webkit-scrollbar-thumb,
          .items-table .ant-table-body::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3);
            border-radius: 8px;
          }
          .ant-table-wrapper .ant-table-thead > tr > th {
            background: #E13F57 !important;
            color: #fff;
            font-weight: 600;
          }
          .ant-table-tbody > tr.row-even > td {
            background: #ffffff;
          }
          .ant-table-tbody > tr.row-odd > td {
            background: oklch(0.98 0.01 71.17);
          }
          .ant-table-tbody > tr:hover > td {
            background: #FDECEF !important;
          }
          .ant-table-tbody > tr.ant-table-row-selected > td {
            background: #FDECEF !important;
          }
          .tbl-footer {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 8px;
            border: 1px solid #f0f0f0;
            border-top: none;
            border-radius: 0 0 8px 8px;
            background: #fff;
          }
          .tbl-footer .left {
            font-size: 12px;
            color: #555;
          }
          .tbl-footer .right {
            display: flex;
            align-items: center;
          }
          .tbl-body-rel {
            position: relative;
          }
          .tbl-body-rel2 {
            position: relative;
          }

          .tbody-loading {
            position: absolute;
            inset: 42px 0 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.6);
            pointer-events: none;
          }

          .item-name-link:hover {
            text-decoration: underline;
          }

          .ant-table-tbody a.item-name-link {
            color: #050505ff;
            text-decoration: none !important;
            cursor: pointer;
          }

          .ant-table-tbody a.item-name-link:hover {
            text-decoration: underline !important;
          }
        `}</style>
      </>
    </>
  );
}

export default Main;
